var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ff9100;\n      }\n\n      .st1 {\n        fill: #ffc400;\n      }\n\n      .st2 {\n        fill: #ff7800;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.9,497.3c21.4,8.6,44.7,13.8,69.1,14.6,33,1.1,64.4-5.7,92.5-18.6-33.7-13.2-64.2-32.6-90.2-56.6-16.9,27-41.8,48.3-71.4,60.7h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.2,436.6c-59.4-54.9-95.4-134.5-92.4-221.7.1-2.8.3-5.6.4-8.5-10.6-2.8-21.8-4.4-33.2-4.8-16.4-.6-32.2,1.4-47.2,5.7-15.9,27.8-25.4,59.6-26.6,93.8-3.1,88.1,50.2,165.1,127.5,196.2,29.6-12.4,54.5-33.6,71.4-60.7h.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.2,436.6c13.8-22.1,22.2-48,23.1-75.9,2.6-73.4-46.8-136.6-115.1-154.2-.2,2.8-.3,5.6-.4,8.5-3,87.2,33,166.7,92.4,221.7h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.8,0c-38.9,31.2-69.6,72.3-88.2,119.6-10.6,27.1-17.4,56.3-19.3,86.8,68.4,17.6,117.7,80.8,115.1,154.2-1,27.9-9.4,53.8-23.1,75.9,26,24.1,56.5,43.4,90.2,56.6,67.6-31.3,115.5-98.5,118.3-178,1.8-51.5-18-97.4-46-136.2C384.2,138.1,266.8,0,266.8,0h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.3448886e8d7478545c29c4f0f7438088.svg";
export { ForwardRef as ReactComponent };